import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { openShoppingListsModalFromBasket } from 'apps/shoppingLists/actions/shoppingLists';
import { isUserLoggedIn } from 'apps/user/helpers';

import TrolleyMenuFooter from '../components/TrolleyMenuFooter';
import { isCustomerAcquisition2018 } from '../../../features';

const connectedTrolleyMenuFooter = connect(
  state => ({
    isBottomCheckoutVisible: isCustomerAcquisition2018(state),
    isLoggedIn: isUserLoggedIn(state.user),
  }),
  {
    openShoppingListsModalFromBasket,
  }
)(TrolleyMenuFooter);

export default withRouter(connectedTrolleyMenuFooter);
